import React, { useState, useEffect, useRef } from 'react';
import { Modal, Input, Row, Col, Button, Typography, message } from 'antd';
import request from 'src/utils/request';
import openNotificationWithIcon from '../Notification';
import { PMS_APIs } from 'src/configs/API';

const { Text } = Typography;

export default function VerifyCodeViewTrackingModal({ open, onClose, onSend, messages }) {
  const CODE_LENGTH = 4;

  const [code, setCode] = useState(Array(CODE_LENGTH).fill(''));
  const inputRefs = useRef([]);
  useEffect(() => {
    if (!open) return;
    setCode(Array(CODE_LENGTH).fill(''));
  }, [open]);

  const handleChange = (value, index) => {
    if (!/^[0-9]*$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value.slice(-1);
    setCode(newCode);

    if (value && index < CODE_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text') || '';
    const digits = paste.replace(/[^0-9]/g, '').slice(0, CODE_LENGTH).split('');
    if (digits.length === 0) return;

    const newCode = Array(CODE_LENGTH).fill('');
    digits.forEach((d, i) => (newCode[i] = d));
    setCode(newCode);

    // focus next empty or last
    const firstEmpty = newCode.findIndex(c => c === '');
    if (firstEmpty === -1) {
      inputRefs.current[CODE_LENGTH - 1]?.focus();
      const finalCode = newCode.join('');
      if (finalCode.length === CODE_LENGTH) {
    } else {
      inputRefs.current[firstEmpty]?.focus();
    }
  }
};

  const handleSubmit = () => {
    const finalCode = code.join('');
    if (finalCode.length === CODE_LENGTH) {
      onSend?.(finalCode);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      title={<div style={{ textAlign: 'center', fontSize: 14, fontWeight: 600 }}>Vui lòng nhập 4 số cuối điện thoại người nhận</div>}
    >
      <Row gutter={12} justify="center" style={{ marginBottom: 16 }}>
        {code.map((digit, idx) => (
          <Col key={idx} span={3}>
            <Input
              maxLength={1}
              value={digit}
              onChange={e => handleChange(e.target.value, idx)}
              onKeyDown={e => handleKeyDown(e, idx)}
              onPaste={handlePaste}
              ref={ref => (inputRefs.current[idx] = ref)}
              style={{
                height: 50,
                width: 50,
                textAlign: 'center',
                fontSize: 20,
                borderRadius: 8
              }}
            />
          </Col>
        ))}
      </Row>

      <Button
        type="primary"
        block
        style={{ height: 44 }}
        onClick={handleSubmit}
        disabled={code.some(c => c === '')}
      >
        Xác nhận
      </Button>
    </Modal>
  );
}
